export default "__VITE_ASSET__ChmdRiQC__"